'use client';

import config from '@actr/config';
import { Button } from '@actr/ui/src/components/_atoms/button';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import { Price } from '@actr/ui/src/components/price';
import { DecodeImageQuality, getDecodeImage } from '@actr/utilities/src/url/decode-image';
import React, { memo } from 'react';

import { ProfitableDirections } from '@/services/models/avia/country';
import { appendChannelToUrl } from '@/utils/channel-data';

import * as Styled from './style.css';

const CountryProfitableDirections: React.FC<ProfitableDirections> = props => {
  const { title, list } = props || {};

  return (
    <ContentBlock className={Styled.ContentBlock} id="from_country_profitable_directions">
      <Text tagName="h3" font="title.x2l">{title}</Text>
      <div className={Styled.CitiesContainer}>
        {
          list!.map((direction, index) => (
            <div className={Styled.CityContainer} key={index}>
              <img
                className={Styled.CityImg}
                src={getDecodeImage(direction.city_img, DecodeImageQuality.Q30)}
                alt={direction.title}
              />
              <div className={Styled.CityInfo}>
                <Text font="title.m">
                  { direction.title.replace('Авиабилеты из', 'Из') }
                </Text>
                <div>
                  {
                    direction.airlines.map((one, supplierIndex) => (
                      <div className={Styled.SuppliersContainer} key={supplierIndex}>
                        <img
                          className={Styled.Supplier}
                          src={`${config.staticURL}/suppliers_redesign/square/${one.code}.png`}
                          alt={`${one.code}`}
                        />
                        <Text font="paragraph.s">
                          { one.title }
                        </Text>
                      </div>
                    ))
                  }
                </div>
                <Text font="paragraph.s">
                  { direction.description }
                </Text>
              </div>
              <div className={Styled.CityInfo}>
                <Text font="title.m">
                  от
                  {' '}
                  <Price amount={direction.min_price} font="title.m" />
                </Text>
                <Button
                  onClick={() => { window.location.href = appendChannelToUrl(direction.url); }}
                  fullWidth={true}>
                  Найти билеты
                </Button>
              </div>
            </div>
          ))
        }
      </div>
    </ContentBlock>
  );
};

export default memo(CountryProfitableDirections);
